import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { BranchService } from 'src/app/services/branch.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-comanda',
  templateUrl: './comanda.component.html',
  styleUrls: ['./comanda.component.scss']
})
export class ComandaComponent implements OnInit {
  @Input() public orderObj: any;
  @Input() public orderItems: any;
  isSecondPrint: boolean = false;
  @Input() isComanda: boolean = false;
  @Input() isInvoice: boolean = false;
  @Input() isFromIncoming: boolean = false;
  data: any;
  qrDomain: string = null;
  sequentialPrint: boolean = false;
  preparationZones: any[] = [];
  appId: string = environment.PARSE_APP_ID;
  printing: boolean = false;

  constructor(public dialogRef: MatDialogRef<ComandaComponent>,
    private branchService: BranchService, public dialog: MatDialog) {

    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.branchService.getSettings().then(res => {
      if (res.success && res.data && res.data.length > 0) {
        this.qrDomain = res.data[0].qrDomain;
        this.sequentialPrint = res.data[0].sequentialPrint;
      }
    });
  }

  print() {
    window.print();  
    this.dialogRef.close();
  }

}
